import React from "react";
import Layout from "./components/Layout/Layout";
import { Amplify } from 'aws-amplify';
import awsExports from './aws-exports';
Amplify.configure(awsExports);

function App() {
  return <Layout />
}

export default App;
